import React, { useEffect, useState } from 'react';
import { Card, Badge, Spinner, ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getDashboard_PendingByAssignee } from 'functions/dashboard';

const PendingTickets = ({ companyId }) => {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const res = await getDashboard_PendingByAssignee(companyId, token);
        if (Array.isArray(res)) {
          setSummary(res);
        }
      } catch (error) {
        console.error('Error loading pending tickets by assignee:', error);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [companyId]);

  const totalPending = summary.reduce((acc, s) => acc + (s.PendingCount || 0), 0);

  const barColors = ['primary', 'info', 'warning', 'danger', 'success', 'secondary'];

  return (
    <Card className="h-100" style={{ border: '1px solid #e3e6ea' }}>
      {/* Header */}
      <Card.Header className="bg-light py-2 d-flex align-items-center">
        <h6 className="mb-0 me-2">Pending Tickets</h6>

      </Card.Header>

      <Card.Body className="p-3">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center p-4">
            <Spinner animation="border" size="sm" className="me-2" />
            <span className="text-muted fs--1">Loading...</span>
          </div>
        ) : summary.length === 0 ? (
          <div className="text-center py-4 text-muted fs--1">✅ No pending tickets</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <p className="text-muted fs--2 fw-semi-bold mb-1 text-uppercase" style={{ letterSpacing: '0.05em' }}>
              Pending count by assignee
            </p>
            {summary.map((row, idx) => {
              const pct = totalPending > 0 ? Math.round((row.PendingCount / totalPending) * 100) : 0;
              const color = barColors[idx % barColors.length];
              return (
                <div key={row.Assignee}>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="fs-0 fw-medium text-800">{row.Assignee}</span>
                    <span className="fs-0 fw-bold text-700">
                      {row.PendingCount}
                      <span className="text-muted fw-normal ms-1" style={{ fontSize: '0.85rem' }}>
                        ({pct}%)
                      </span>
                    </span>
                  </div>
                  <ProgressBar
                    now={pct}
                    variant={color}
                    style={{ height: '8px', borderRadius: '4px' }}
                  />
                </div>
              );
            })}
          </div>
        )}
      </Card.Body>

      <Card.Footer className="bg-light py-2 text-center">
        <Link to="/support-desk/table-view/5/0" className="fw-semi-bold fs--1">
          View all tickets
        </Link>
      </Card.Footer>
    </Card>
  );
};

export default PendingTickets;
